import React from 'react';
import { useDispatch } from 'react-redux';

import { resetSearch } from '../../../redux/actions/searchAction';
import s from './CriminalInfo.module.scss';

const CriminalsInfo = ({ data }) => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    return () => {
      dispatch(resetSearch());
    };
  }, []);

  return (
    <div className={s.content_window}>
      <h2>Возможные совпадения</h2>
      <div className={s.content_card}>
        {data &&
          data.length !== 0 &&
          data.map((i) => {
            const emptyPossibleNames = i.possibleNames && i.possibleNames !== 0;
            const birth = [];
            if (i.birthday) birth.push(i.birthday);
            if (i.citizenship) birth.push(i.citizenship);
            if (i.address) birth.push(i.address);

            return (
              <div className={s.content_card_item}>
                <p>
                  <span>ФИО:</span> {i.name}
                  {emptyPossibleNames && ` (${i.possibleNames.join(', ')})`}
                </p>
                <p>
                  <span>Родился:</span> {birth.join(', ') ? birth.join(', ') : 'неизвестно'}
                </p>
                <p>
                  <span>Основание/справочная информация:</span> {i.reason}{' '}
                  {i.information && `. ${i.information}`}
                </p>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default CriminalsInfo;
